export default "__VITE_ASSET__Bepfw5wu__"